import React, { useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
} from "@reach/accordion";
import css from "@styled-system/css";

import {
  Box,
  ColorMode,
  Column,
  Columns,
  Flex,
  Heading,
  RichText as RichTextComponent,
  Wrapper,
} from "components";
import { PrismicColor } from "utils";

function AccordionGroup({ background, content, items, title }) {
  const [firstActive] = useState(() => {
    let found = 0;
    if (items) {
      items.forEach((item, index) => {
        if (item.featured) {
          found = index;
        }
      });
    }
    return found;
  });
  if (items && items[0])
    return (
      <Wrapper
        id={title && title.text}
        py={{ _: "layout.5", md: "layout.6" }}
        bg={PrismicColor(background)}
      >
        <Columns spaceX="layout.5" spaceY="layout.4">
          <Column width={{ _: 1 / 1, lg: 4 / 12 }}>
            {/* Title */}
            {title && title.text && (
              <Heading children={title.text} as="h2" size={700} />
            )}
          </Column>
          {/* Subtitle */}
          <Column width={{ _: 1 / 1, lg: 8 / 12 }}>
            {content && content.html && (
              <RichTextComponent
                html={content.html}
                size={400}
                maxWidth="65ch"
              />
            )}
          </Column>
        </Columns>
        {/* Accordion Items */}
        <Box position="relative" my={{ _: "layout.3", md: "layout.4" }}>
          <Accordion
            defaultIndex={firstActive}
            css={css({
              '[data-reach-accordion-button][aria-expanded="true"]': {
                bg: "brand.secondary",
              },
              "[data-reach-accordion-button]": {
                bg: "brand.primary",
                transition: "background 300ms ease-out",
              },
            })}
          >
            {items.map((item, index) => (
              <AccordionItem key={title && title.text + "accordion" + index}>
                <Columns>
                  <Column width={{ _: 1 / 1, lg: 4 / 12 }}>
                    <ColorMode mode="dark">
                      <AccordionButton
                        css={{ width: "100%", cursor: "pointer" }}
                      >
                        <Box
                          px="layout.1"
                          py={{ _: "layout.3", lg: "40px" }}
                          width="100%"
                        >
                          <Heading size={500} textAlign="left">
                            {item.title && item.title.text
                              ? item.title.text
                              : null}
                          </Heading>
                          {item.featured && (
                            <Flex alignItems="center" mt="layout.1">
                              {/* GLYPH */}

                              <svg
                                width="16"
                                height="18"
                                viewBox="0 0 546 625"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M125.2 274.736L0 512.568L240.318 625V274.736H125.2Z"
                                  fill="#FFF"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M302.211 274.736V625L542.539 512.568L417.329 274.736H302.211Z"
                                  fill="#FFF"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M271.986 5.20508L168.363 198.34H374.176L271.986 5.20508Z"
                                  fill="#FFF"
                                />
                              </svg>
                              <Heading
                                children="Our Approach"
                                ml="spacing.4"
                                size={400}
                                css={{
                                  textTransform: "uppercase",
                                  fontSize: "12px",
                                  lineHeight: "12px",
                                }}
                              />
                            </Flex>
                          )}
                        </Box>
                      </AccordionButton>
                    </ColorMode>
                  </Column>

                  <AccordionPanel css={{ width: "100%" }}>
                    <Box
                      position={{ _: "relative", lg: "absolute" }}
                      top="0"
                      left={{ _: 0, lg: "33.33333333333%" }}
                      right="0"
                      bottom="0"
                      width={{ _: "100%", lg: "initial" }}
                      bg="background.0"
                    >
                      <Flex
                        flexDirection="column"
                        justifyContent="space-between"
                        p="layout.3"
                        height="100%"
                        position="relative"
                      >
                        <Box pb="layout.4">
                          <Heading size={600} textAlign="left">
                            {item.title && item.title.text
                              ? item.title.text
                              : null}
                          </Heading>
                        </Box>
                        <RichTextComponent
                          html={item.accordion_content.html}
                          size={400}
                          color="label.0"
                          css={{ ul: { paddingLeft: "18px" } }}
                        />
                        <Heading
                          children={item.accordion_highlight}
                          pt="layout.4"
                          size={400}
                          css={{
                            fontWeight: 500,
                            textTransform: "uppercase",
                            fontSize: "12px",
                            lineHeight: "12px",
                          }}
                        />
                      </Flex>
                    </Box>
                  </AccordionPanel>
                </Columns>
              </AccordionItem>
            ))}
          </Accordion>
        </Box>
      </Wrapper>
    );
  else return null;
}

export default AccordionGroup;
